import React from 'react';
import { Button } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { makeStyles } from '@material-ui/core/styles';
import store from 'store';

const useStyles = makeStyles(theme => ({
	logoutButton: {
		marginRight: theme.spacing(1),
		color: '#198754',
		border: '1px solid #198754',
		'&:hover': {
			backgroundColor: '#198754',
			color: '#fff',
			opacity: 0.8,
		},
	},
}));

const Logout = () => {
	const { t } = useTranslation();
	const classes = useStyles();

	const handleLogout = () => {
		store.remove('token');
		window.location.href = '/';
	};
	return (
		<div>
			<Button
				onClick={handleLogout}
				variant='outlined'
				className={classes.logoutButton}
			>
				{t('logout')}
			</Button>
		</div>
	);
};

export default Logout;
